import React from 'react';
import DashboardLayout from '../../components/ui/DashboardLayout';
import Flex from '../../components/ui/Flex';
import { Body1 } from '../../components/ui/Typography';
import { ls } from '../../i18n/translations';
import { Box, useMediaQuery } from '@mui/material';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import UserProfileForm from '../../components/forms/UserProfileForm';
import { useMQ } from '../../hook/useMQ';
import { useMount } from 'react-use';
import config from '../../config';
import { useDarkMode } from '../../hook/useDarkMode';
import { colors } from '../../theme';
import UserOrgChart from '../../components/UserOrgChart';
import { useUsers } from '../../hook/useUsers';
import { useAuth } from '../../hook/useAuth';
import ErrorMessage from '../../components/ErrorMessage';
import LoadingPage from '../../components/ui/LoadingPage';
import { getErrorMessage } from '../../helpers/utils';

const Profile: React.FC = () => {
  const { isMobileOrTablet } = useMQ();
  const { isDarkMode } = useDarkMode();
  const isWideEditLayout = useMediaQuery('(min-width:1920px)');
  const { users, usersLoading, usersError } = useUsers();
  const { user } = useAuth();

  useMount(() => {
    if (!config.env.isDev) {
      window.scroll(0, 0);
    }
  });

  if (usersLoading) {
    return <LoadingPage />;
  }

  return (
    <DashboardLayout>
      <ErrorMessage
        containerStyle={{ paddingBottom: 2, textAlign: 'center' }}
        message={getErrorMessage(usersError)}
      />
      <Box p={2} pt={isMobileOrTablet ? 0 : 2}>
        <Breadcrumbs
          // comeBackLink={PageName.home}
          backPageName={ls.dashboard}
        />
      </Box>
      <Box mx={isMobileOrTablet ? 2 : 0}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: isWideEditLayout ? 'row' : 'column',
            alignItems: 'stretch',
            gap: isWideEditLayout ? 2 : 0,
          }}
        >
          <Box
            borderRadius={1}
            sx={{ boxShadow: 1, maxWidth: 750, width: '100%', flexShrink: 0 }}
            bgcolor={isDarkMode ? colors.darkBackground2 : 'white'}
            pb={2}
          >
            {/* Same header pattern as EditUser (title + trailing row slot) */}
            <Flex p={2}>
              <Box>
                <Body1 weight={600} size='1.1rem'>
                  {ls.userProfile}
                </Body1>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 35 }} />
            </Flex>
            <Box className='separator' width='100%' />
            <Box m={2}>
              <UserProfileForm />
            </Box>
          </Box>
          <Box
            sx={{
              flex: isWideEditLayout ? '1 1 0%' : 'none',
              minWidth: 0,
              width: '100%',
            }}
          >
            <UserOrgChart
              users={users}
              currentUserId={user?.id}
              sx={isWideEditLayout ? { mt: 0, maxWidth: 'none', width: '100%' } : undefined}
            />
          </Box>
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default Profile;
